import { useEffect, useRef } from "react";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import Const from "../../../const/Const";
import { ModalClose } from "../../atoms/modalClose";

const EstheticCoursePopupContainer = (props) => {
    const {
        state,
        onClickCloseCoursePopup,
        cornerBunKbn,
    } = props;
    const isWidePhone = useMedia({ maxWidth: '480px' });

    const courseData = state.courseData;

    const popupRef = useRef(null);

    useEffect(() => {
        popupRef.current.scrollTop = 0;
    }, [state.coursePopup]);

    return (
        <div className={state.coursePopup ? "popupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={isWidePhone ? "bookConfirm inputUserPopupInner_media" : "bookConfirm inputUserPopupInner"}>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickCloseCoursePopup} />
                    <h4 className="popupInnerText" >　</h4>
                </div>
                <div className="popupCourseTerm" >
                    {courseData?.courseTeikyoStartDate && courseData.courseTeikyoStartDate != Const.COURSE_START_LIMIT
                        && courseData?.courseTeikyoEndDate && courseData.courseTeikyoEndDate != Const.COURSE_END_LIMIT ?
                        <>
                            {commonUtil.getStringFromDate(new Date(courseData.courseTeikyoStartDate), "yyyy.MM.dd") + "-" + commonUtil.getStringFromDate(new Date(courseData.courseTeikyoEndDate), "yyyy.MM.dd")}
                            <br />
                        </>
                        :
                        ""}
                </div>
                <div className="popupCourseName" >
                    {courseData?.courseName ? courseData.courseName : "　"}
                </div>
                <div className="listDetailPopupImgWrap" >
                    <img src={courseData.courseGazoURL} alt="" className="listDetailPopupImg" />
                </div>
                <div className="listDetailPopupInfo">
                    <p className="courseInfo1">{courseData?.courseNaiyoSetsumeibun1 ? courseData.courseNaiyoSetsumeibun1 : ""}</p>
                    <p className="coursePrice">{courseData?.tanka ? courseData.tanka.toLocaleString() + (cornerBunKbn == "1" ? "円(税・サ込)" : "円(税込)") : cornerBunKbn == "1" ? "0円(税・サ込)" : "0円(税込)"}</p>
                    <p className="courseInfo2">{courseData?.courseNaiyoSetsumeibun2 ? courseData.courseNaiyoSetsumeibun2 : ""}</p>
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div>
    );
};

export default EstheticCoursePopupContainer;
